import React from "react";

const Footer = () => {
  const telephoneNumbers = [
    "022 28302364",
    "022 650 78348",
    "022 2823 8909",
    "022 28310132"
  ];
  return (
    <footer className="footer bg-main text-white">
      <div className="content text-center 2xl:text-xl">
        <p>
          <p>
            Marol Naka Metro Station, Sir M. V. Road, Andheri (East), Mumbai -
            400059
          </p>
          <p>
            <strong className="text-white">
              For Further Queries Please Contact:
            </strong>
          </p>
          <div className="contact-container lg:flex lg:relative lg:m-auto lg:gap-3 lg:items-start lg:justify-center">
            <p>
              <strong className="text-white tracking-wide">Landline:</strong>{" "}
              <i>022-2830-2364</i>
              <br />
              <strong className="text-white tracking-wide">Cell: </strong>
              <i>720-807-8348</i>
              <br />
              <strong className="text-white tracking-wide">
                Mrs. Waheeda:{" "}
              </strong>
              <i>839-800-546</i>
            </p>

            <p>
              <strong className="text-white tracking-wide">
                Telephone Numbers:
              </strong>
              <br />
              <ul className="mr-1 mt-0 relative lg:grid lg:grid-cols-2 lg:gap-x-10">
                {telephoneNumbers.map((number) => (
                  <li className="m-0">{number}</li>
                ))}
              </ul>
            </p>
          </div>
          <p>
            or <br />
            <strong className="text-white">Send us a message at</strong>{" "}
            <i>
              <a className="underline" href="mailto:medicareh@yahoo.com">
                medicareh@yahoo.com
              </a>
            </i>
          </p>
        </p>
      </div>
      <div className="absolute bottom-5 float-center text-center text-white">
        Designed and Developed by{" "}
        <a
          href="https://hammaadmemon.com"
          className="text-white underline"
          target="_blank"
          rel="noreferrer"
        >
          Hammaad Memon
        </a>
      </div>
    </footer>
  );
};

export default Footer;
